module.exports = __webpack_public_path__ + "static/bc-logo-svg-d931038535635ba5256fb5f825e1e5c8.svg";